export const headerLayout = 2
export const mobileLayout = 1

// Forgotten password version - 1, 2
export const forgotPasswordVersion = 2

export const contactConfig = {
    phoneNumber: '+49 151 2417 1320',
    mail: 'info@abamalwelt.de',
}

$('body').addClass(`header-layout-${headerLayout}`)
$('body').addClass(`able-mobile-layout-${mobileLayout}`)
